import s from '@/styles/components/Toast.module.scss'
import { ButtonTapHighlight, ToastPortal } from '@/components'
import { AnimatePresence } from 'framer-motion'
import { MotionDiv } from '@/components'

interface Props {
  isVisible: boolean;
  message: string;
  linkText?: string;
  handleClick?: () => void;
}

const sheetVariants = {
  initial: { y: '100%', opacity: 0 },
  animate: { y: 0, opacity: 1 },
  exit: { y: '100%', opacity: 0 },
}
const timing = { duration: 0.3, ease: 'easeOut' as const }

function Toast(props: Props) {
  const { isVisible, message, linkText, handleClick } = props

  return (
    <ToastPortal rootElementSelector={'#root'}>
      <AnimatePresence>
        {isVisible && (
          <MotionDiv
            className={s.wrap}
            variants={sheetVariants}
            initial="initial"
            animate="animate"
            exit="exit"
            transition={timing}
          >
            <div className={s.content}>
              {message}
              {linkText && (
                <ButtonTapHighlight
                  className={s.link}
                  onClick={handleClick}
                >
                  {linkText}
                </ButtonTapHighlight>
              )}
            </div>
          </MotionDiv>
        )}
      </AnimatePresence>
    </ToastPortal>
  )
}

Toast.displayName = 'Toast'
export { Toast }
